import React, { useState } from "react";
import { defineMessages, useIntl } from "react-intl";

import AccountIcon from "../common/icons/accountIcon";
import AssignTask from "../assignTask/assignTask";
import { STATUSES } from "../../globals/workOrderStatus";

const messages = defineMessages({
    unassignedResourceValue: {
        id: "assigned-to-field.unassigned-value",
        defaultMessage: "Unassigned",
        description: "default value if work order is unassigned",
    },
    assignedResourceTitle: {
        id: "assigned-to-field.assigned-to-field-title",
        defaultMessage: "Assigned resource",
        description: "title for button to change or see assigned resource",
    },
});
export const AssignedToFormatter = (intl, params) => {
    const resource = params.value;
    var value = intl.formatMessage(messages.unassignedResourceValue);

    if (resource && resource.firstName && resource.lastName) {
        const fName = resource.firstName[0].toUpperCase() + resource.firstName.substring(1);
        const lName = resource.lastName[0].toUpperCase() + resource.lastName.substring(1);
        value = `${fName} ${lName}`;
    }

    return value;
};
export const AssignedTaskModal = (props) => {
    const intl = useIntl();
    const { params, task } = props;
    const [showAssignmentModal, setShowAssignmentModal] = useState(false);
    const tech = params.value ? AssignedToFormatter(intl, params) : intl.formatMessage(messages.unassignedResourceValue);

    return task ? (
        <React.Fragment>
            <div className="task-item-field assigned-to" role="assignedtofield" onMouseDown={() => setShowAssignmentModal(true)}>
                <AccountIcon title={intl.formatMessage(messages.assignedResourceTitle)} />
                {tech.trim()}
            </div>
            <AssignTask workOrder={task} show={showAssignmentModal} close={() => setShowAssignmentModal(false)} isUnassigned={true} />
        </React.Fragment>
    ) : null;
};

const AssignToRenderer = (params) => {
    const intl = useIntl();
    const task = params.row;
    const tech = AssignedToFormatter(intl, params);

    return (
        // <CustomizedDialogs/>
        [STATUSES.UNASSIGNED, STATUSES.ASSIGNED, STATUSES.INCOMPLETE].includes(task["statusId"]) ? (
            <AssignedTaskModal params={params} task={task} />
        ) : (
            <div className="task-item-field">
                <AccountIcon title={intl.formatMessage(messages.assignedResourceTitle)} color="#3b3b3b" />
                {tech.trim()}
            </div>
        )
    );
};

export default AssignToRenderer;
